import { parse } from 'query-string'

export const filterString = <T>(value: T | string | null | undefined | void): value is string =>
    typeof value === 'string'

export interface ParsedQueryParams {
    [key: string]: string
}

export const parseParams = (search: string, defaults?: ParsedQueryParams): ParsedQueryParams => {
    const { a, ...parsedSearch } = parse(search)
    const parsedB64 = typeof a === 'string' ? parse(atob(a)) : {}
    const mergedDefaults = { ...defaults, ...parsedB64, ...parsedSearch }

    return Object.fromEntries(
        Object.entries(mergedDefaults)
            .map(([k, v]) => (typeof v === 'string' ? [k, v] : [k, undefined]))
            .filter(([, v]) => filterString(v)),
    )
}
